module.exports = __webpack_public_path__ + "static/10-2ed33c200a29ff12c44db3298578785c.jpg";